import { render, staticRenderFns } from "./TrainingTab.vue?vue&type=template&id=5cd4ebb1"
import script from "./TrainingTab.vue?vue&type=script&lang=js"
export * from "./TrainingTab.vue?vue&type=script&lang=js"
import style0 from "./TrainingTab.vue?vue&type=style&index=0&id=5cd4ebb1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports